import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getRangeValue } from '../../../packages/JsonQuery';
import { DEFAULT_RANGE_VALUE } from 'shared/constants/defaultValues';

export const selectFloorsCount = createSelector(
  selectJsonQuery,
  jsonQuery => getRangeValue('floorn')(jsonQuery) || DEFAULT_RANGE_VALUE,
);
